import { render, staticRenderFns } from "./PopupList.vue?vue&type=template&id=4eac0ebc&"
import script from "./PopupList.vue?vue&type=script&lang=js&"
export * from "./PopupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports